/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import Tysiav2Launch from 'DesignSystem/Svgs/Tysiav2Launch/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Url/Content"
  
}) {
let treatmentPlanRequestUrlValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_request',
path: 'url',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="normal"
 weight="medium"
 flexShrink={1}
 maxWidth={200}
 data="treatment_plan_request.url"
 text={treatmentPlanRequestUrlValueData}
 goTo={treatmentPlanRequestUrlValueData}
/>
<Tysiav2Launch
  viewPath={`${viewPath}/Tysiav2Launch`}
 flexShrink={0}
 width={16}
 height={16}
 stroke={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}